import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUnite = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M9.47 11.19a.75.75 0 0 1-.22-.53v-6.5a.75.75 0 1 1 1.5 0v6.189l5.28 5.28a.75.75 0 1 1-1.06 1.06z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M3.97 16.69a.75.75 0 0 1 0-1.061l5-5a.75.75 0 1 1 1.06 1.06l-5 5a.75.75 0 0 1-1.06 0ZM7.31 6.11a.75.75 0 0 1 0-1.06l2.08-2.08a.75.75 0 0 1 1.06 0l2.08 2.08a.75.75 0 0 1-1.06 1.06L9.92 4.56 8.37 6.11a.75.75 0 0 1-1.06 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgUnite;
